<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/X3oWMz/tc-custom/9781398480360.jpg?1682168954386" alt="This image is the cover for the book Breeding"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Breeding
      </h1>
      <p class="bookDescription body article font2">
        <p>A strain of vampires with super strength, a sixth sense, and the ability to shape change, who can kill in seconds. It is a race against time to find a way to capture all of them and destroy them. But how? In a sleepy town in England close to the southern coast, Carlos and his loving wife Tanya and their teenage son Lewis are put through the worst nightmare they could ever imagine: a plague of vampires. They must not only fight to save their lives but the whole town. No one is safe, not even your children. Your blood is not the only thing they need.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Westwood
      </h2>
      
      <p class="authorDescription body article">John Westwood began his career as an actor working in theatre, film, television, and voiceover. Musical theatre was his first introduction to performing and entertaining. Highlights for John were working with Petula Clark in London’s West End and Madonna in a music video. John is a fan of horror movies, especially hammer horror films with the ultimate Dracula, and John’s idol, Sir Christopher Lee. Years later, he met his idol who became a friend. He is an award-winning country singer and a screenwriter. When he is not writing, he relaxes by painting with acrylics or pastels.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4796d856